import { Button } from "@light-technology/components";
import { LinkExternal01 } from "@untitledui/icons";
import { DOCS_QUICKSTART_URL } from "../../utilities/constants";

export function NoAccountsState() {
  return (
    <div className="mt-[28px] flex flex-1 flex-col items-center justify-center gap-xl px-3xl pt-3xl pb-3xl text-center">
      <div className="flex max-w-md flex-col gap-md">
        <h4 className="text-lg font-semibold">No accounts yet</h4>
        <p className="text-sm text-tertiary">
          Start enrolling your first customer to see customer account
          information appear here.
        </p>
      </div>
      <Button
        color="primary"
        size="md"
        iconLeading={LinkExternal01}
        href={DOCS_QUICKSTART_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Read Quickstart
      </Button>
    </div>
  );
}
